import React from "react";
import _ from "lodash";
import ImageLink from "../components/common/ImageLink";

import { Formik } from "formik";
import axios from "axios";
import { Div, Text, Button, Modal, Input, Icon, Image } from "atomize";
import * as yup from "yup";
import { getUTMcookie, addUtmInputValues } from "../utilities/helpers";

export const validator = yup.object().shape({
  email: yup
    .string()
    .required()
    .min(1)
    .email(),
});

const HowModal = ({ isOpen, onClose }) => {
  let formikProps;

  /**
   * on submit form
   */
  let onSubmit = values => {
    if (
      values.email.indexOf("@gmail") > -1 ||
      values.email.indexOf("@yahoo") > -1 ||
      values.email.indexOf("@hotmail") > -1
    ) {
      formikProps.setSubmitting(false);
      formikProps.setStatus({
        errorMessage: "Please enter your work email address.",
      });

      return false;
    }

    const utmArray = getUTMcookie();
    const inputs = addUtmInputValues(values, utmArray);

    axios
      .post("/api/product-tour", inputs)
      .then(() => {
        formikProps.setSubmitting(false);
        formikProps.resetForm();
        formikProps.setStatus({
          successMessage: "Submitted!",
          errorMessage: null,
        });

        onClose();
        localStorage.setItem("modalState", false);
        document
          .querySelector(
            ".how-full-slider .swiper-slide:first-child .video-react-big-play-button"
          )
          .click();
      })
      .catch(error => {
        formikProps.setSubmitting(false);
        formikProps.setStatus({
          successMessage: null,
          errorMessage: "Something went wrong",
        });
      });
  };

  return (
    <Modal
      isOpen={isOpen}
      m={{ xs: "0" }}
      d={{ xs: "flex" }}
      style={{ alignItems: "center" }}
      maxW={{ lg: "38.75rem", md: "38.75rem", xs: "100vw" }}
      h={{ lg: "24.94rem", md: "24.94rem", xs: "100vh" }}
      rounded="sm"
      zIndex={3}
      align={{ lg: "center", xs: "center" }}
    >
      <Div w="100%" maxW={{ lg: "100%", md: "100%", xs: "21rem" }} m="0 auto">
        <ImageLink link="">
          <Image h="1rem" src="/images/trend-logo-white.svg" />
        </ImageLink>
        <Div
          textAlign="center"
          m={{ b: { lg: "2.2rem", xs: "4rem" }, t: { xs: "1rem" } }}
          d="flex"
          justify="center"
        >
          <Text
            textColor="dark"
            textWeight="700"
            textSize={{ xs: "title3", md: "title2" }}
            maxW="31.875rem"
          >
            enter your work email to take a self guided tour.
          </Text>
        </Div>
        <Div>
          <Div maxW="25rem" m="auto">
            <Text
              textSize="caption2"
              textWeight="700"
              m={{ b: ".7rem" }}
              textColor="dark"
            >
              Company Email
            </Text>
            <Formik
              initialValues={{
                email: "",
              }}
              validationSchema={validator}
              onSubmit={onSubmit}
            >
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  status,
                  setFieldValue,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  submitCount,
                  handleSubmit,
                } = props;

                formikProps = props;

                return (
                  <form onSubmit={handleSubmit}>
                    <Div>
                      <Div d="flex">
                        <Div
                          d="flex"
                          align="center"
                          w={{ xs: "100vw", lg: "100%" }}
                          textColor="black"
                        >
                          <Div
                            d="flex"
                            flexDir="column"
                            justify="space-evenly"
                            m="0 auto"
                            w="100%"
                          >
                            <Div maxW={{ md: "25rem" }}>
                              <Div m={{ b: "1.4rem" }}>
                                <Div>
                                  <Input
                                    required
                                    type="email"
                                    name="email"
                                    value={values.email}
                                    bg="gray200"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="youremail@email.com"
                                    rounded="xs"
                                    fontFamily="secondary"
                                    h="3.125rem"
                                    textSize={{
                                      xs: "caption2",
                                      md: "14px",
                                    }}
                                    border="none"
                                    suffix={
                                      <Button
                                        pos="absolute"
                                        onClick={handleSubmit}
                                        bg="primary"
                                        hoverBg="primary700"
                                        textColor="black"
                                        top="0"
                                        type="submit"
                                        right="0"
                                        h="3.125rem"
                                        textSize={{
                                          xs: "caption2",
                                          md: "14px",
                                        }}
                                        p={{
                                          x: { xs: "1rem", md: "1.9rem" },
                                        }}
                                        textWeight="700"
                                        fontFamily="secondary"
                                        rounded={{ r: "xs" }}
                                      >
                                        Continue Tour!
                                      </Button>
                                    }
                                  />
                                  <p>{touched.email && errors.email}</p>
                                  <Text
                                    textColor="danger800"
                                    m={{ t: "0.5rem" }}
                                  >
                                    {_.get(status, "errorMessage")}
                                  </Text>
                                </Div>
                              </Div>
                            </Div>
                          </Div>
                        </Div>
                      </Div>
                    </Div>
                  </form>
                );
              }}
            </Formik>
          </Div>
        </Div>
      </Div>
    </Modal>
  );
};

export default HowModal;
